(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sakemi-custom-header-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── DOM refs ── */
  var header      = document.getElementById('skm-header');
  var burger      = document.getElementById('skm-burger');
  var drawer      = document.getElementById('skm-drawer');
  var overlay     = document.getElementById('skm-overlay');
  var drawerClose = document.getElementById('skm-drawer-close');
  var searchToggle = document.getElementById('skm-search-toggle');
  var searchBar   = document.getElementById('skm-search-bar');
  var searchClose = document.getElementById('skm-search-close');
  var searchInput = document.getElementById('skm-search-input');
  var spacer      = document.getElementById('skm-hdr-spacer');

  /* ════ STICKY — add shadow on scroll ════ */
  if (header && header.classList.contains('skm-hdr--sticky')) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });

    /* Sync spacer height with actual header height */
    if (spacer) {
      function syncSpacer() {
        spacer.style.height = header.offsetHeight + 'px';
      }
      syncSpacer();
      window.addEventListener('resize', syncSpacer, { passive: true });
    }
  }

  /* ════ DRAWER ════ */
  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.hidden  = false;
    overlay.hidden = false;
    drawer.removeAttribute('hidden');
    overlay.removeAttribute('hidden');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
    });
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) { burger.setAttribute('aria-expanded', 'true'); burger.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
    /* Focus first focusable element in drawer */
    var focusable = drawer.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    if (focusable) setTimeout(function () { focusable.focus(); }, 300);
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.classList.remove('is-open'); }
    document.body.style.overflow = '';
    setTimeout(function () {
      /* Keep in DOM but visually hidden via transform */
    }, 320);
    if (burger) burger.focus();
  }

  if (burger)      burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay)     overlay.addEventListener('click', closeDrawer);

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      if (searchBar && !searchBar.hidden) closeSearch();
    }
  });

  /* ════ DRAWER ACCORDION SUB-MENUS ════ */
  var toggleBtns = document.querySelectorAll('.skm-drawer__link--toggle');
  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      /* Close all others */
      toggleBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var s = b.nextElementSibling;
        if (s && s.classList.contains('skm-drawer__sub')) s.classList.remove('is-open');
      });
      /* Toggle clicked */
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        var sub = this.nextElementSibling;
        if (sub && sub.classList.contains('skm-drawer__sub')) sub.classList.add('is-open');
      }
    });
  });

  /* ════ DESKTOP DROPDOWN ════ */
  var dropBtns = document.querySelectorAll('.skm-hdr__nav-link--btn');
  dropBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      /* Close all */
      dropBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      /* Toggle */
      if (!expanded) this.setAttribute('aria-expanded', 'true');
    });
    /* Close when clicking outside */
    document.addEventListener('click', function (e) {
      if (!btn.closest('.skm-hdr__nav-item').contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ════ SEARCH BAR ════ */
  function openSearch() {
    if (!searchBar) return;
    searchBar.removeAttribute('hidden');
    searchBar.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchBar) return;
    searchBar.setAttribute('hidden', '');
    searchBar.setAttribute('aria-hidden', 'true');
    if (searchToggle) { searchToggle.setAttribute('aria-expanded', 'false'); searchToggle.focus(); }
  }

  if (searchToggle) searchToggle.addEventListener('click', function () {
    searchBar && !searchBar.hidden ? closeSearch() : openSearch();
  });

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* ════ CART COUNT — update on cart change ════ */
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
    if (count === null) return;
    var badge = document.querySelector('.skm-hdr__cart-badge');
    var text  = document.querySelector('.skm-hdr__cart-text');
    if (badge) { badge.textContent = count; badge.style.display = count > 0 ? 'flex' : 'none'; }
    if (text)  text.textContent = 'カート' + (count > 0 ? '(' + count + ')' : '');
    var cartLink = document.querySelector('.skm-hdr__cart');
    if (cartLink) cartLink.setAttribute('aria-label', 'カート — ' + count + '点');
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sakemi-featured-slider-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlider(section) {
    var sid      = section.dataset.sectionId;
    var slides   = Array.from(section.querySelectorAll('.skm-fs__slide'));
    var dots     = Array.from(section.querySelectorAll('.skm-fs__dot'));
    var prevBtn  = section.querySelector('.skm-fs__arrow--prev');
    var nextBtn  = section.querySelector('.skm-fs__arrow--next');
    var autoplay = section.dataset.autoplay === 'true';
    var speed    = parseInt(section.dataset.speed, 10) || 5000;
    var total    = slides.length;
    var current  = 0;
    var timer    = null;

    if (total < 2) return; // single slide — no JS needed

    /* ── Go to slide index ── */
    function goTo(idx) {
      if (idx < 0)      idx = total - 1;
      if (idx >= total) idx = 0;

      /* Deactivate current */
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      /* Activate new */
      current = idx;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    /* ── Autoplay ── */
    function startTimer() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stopTimer()  { clearInterval(timer); }
    function resetTimer() { stopTimer(); startTimer(); }

    /* ── Arrows ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    /* ── Dots ── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.idx, 10));
        resetTimer();
      });
    });

    /* ── Pause on hover ── */
    section.addEventListener('mouseenter', stopTimer);
    section.addEventListener('mouseleave', startTimer);

    /* ── Touch / swipe ── */
    var touchStartX = 0;
    var sliderEl = section.querySelector('.skm-fs__slider');
    if (sliderEl) {
      sliderEl.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      sliderEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 44) {
          dx < 0 ? goTo(current + 1) : goTo(current - 1);
          resetTimer();
        }
      }, { passive: true });
    }

    /* ── Keyboard (arrow keys when focused) ── */
    sliderEl && sliderEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); resetTimer(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); resetTimer(); }
    });

    /* ── Start ── */
    startTimer();
  }

  /* Boot */
  function boot() {
    document.querySelectorAll('.skm-fs[data-section-id]').forEach(initSlider);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.skm-fs');
    if (s) initSlider(s);
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sakemi-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function HeroSlideshow(section) {
    var el       = section;
    var track    = el.querySelector('.skm-hero__track');
    var slides   = el.querySelectorAll('.skm-hero__slide');
    var dots     = el.querySelectorAll('.skm-hero__dot');
    var prevBtn  = el.querySelector('.skm-hero__arrow--prev');
    var nextBtn  = el.querySelector('.skm-hero__arrow--next');
    var autoplay = el.dataset.autoplay === 'true';
    var speed    = parseInt(el.dataset.speed, 10) || 5000;
    var current  = 0;
    var timer    = null;
    var total    = slides.length;

    if (total < 2) return; // single slide — no JS needed

    function goTo(index) {
      // Bounds wrap
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      // Deactivate current
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      // Activate next
      current = index;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function startTimer() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    // Dot clicks
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        resetTimer();
      });
    });

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    // Pause on hover
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', startTimer);

    // Touch swipe
    var touchStartX = 0;
    el.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        goTo(dx < 0 ? current + 1 : current - 1);
        resetTimer();
      }
    }, { passive: true });

    startTimer();
  }

  // Init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.skm-hero[data-section-id]').forEach(function (el) {
      HeroSlideshow(el);
    });
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.skm-hero');
    if (section) HeroSlideshow(section);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sakemi-nav-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function NavPanel(root) {
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('.skm-navpanel__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.skm-navpanel__panel'));
    if (!tabs.length) return;

    function activate(i) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        p.classList.toggle('is-active', on);
        on ? p.removeAttribute('hidden') : p.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var n = i;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft')  n = (i - 1 + tabs.length) % tabs.length;
        if (n !== i) { activate(n); tabs[n].focus(); e.preventDefault(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.skm-navpanel[data-section-id]').forEach(NavPanel);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.skm-navpanel');
    if (el) NavPanel(el);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
